import React from "react";
import { KeyboardArrowLeft } from "@material-ui/icons";
import PropTypes from "prop-types";
import "./style.scss";
import { ErrorMessage } from "../ErrorMessage";
import { handleZipVerification } from "./helpers";
import { CustomButton } from "../../../../components/ui-kit/CustomButtom";
import { formattingZipCode } from "lib/helpers/formatters";

import { useTranslation } from 'react-i18next';

export const AuthFormZip = ({
  handleGoBack,
  isButtonDisabled,
  isZipDisabled,
  handleLogin,
  handleChange,
  defaultZip,
  errorMessage,
  hasError,
}) => {

  const { t } = useTranslation();

  return (
    <div className="auth-form-zip">
      <div className="auth-form__header">
        <h2 className="heading heading-1">{t('Access Your Account')}</h2>
        <p className="heading heading-body-medium">
          {t("Enter your information below to verify your identity")}
        </p>
        <button
          className="button button-text--simple"
          onClick={() => handleGoBack()}
        >
          <KeyboardArrowLeft />
        </button>
      </div>
      {hasError ? <ErrorMessage errorMessage={errorMessage} /> : null}
      <div className="form-group">
        <label htmlFor="zip">ZIP</label>
        <input
          type="text"
          className="form-control"
          id="zip"
          name="zip"
          placeholder="XXXXXXXXX"
          value={formattingZipCode(defaultZip)}
          onChange={handleChange}
        />
      </div>
      <div className="auth-form__submit">
        <CustomButton
          text={t("Access Account")}
          size="large"
          onClickHandler={() => handleZipVerification(handleLogin)}
          disabled={isZipDisabled || isButtonDisabled}
          buttonId="check-zip-button"
        />
      </div>
    </div>
  );
};

AuthFormZip.propTypes = {
  handleGoBack: PropTypes.func,
  isButtonDisabled: PropTypes.bool,
  isZipDisabled: PropTypes.bool,
  handleLogin: PropTypes.func,
  handleChange: PropTypes.func,
  defaultZip: PropTypes.string,
  errorMessage: PropTypes.string,
  hasError: PropTypes.bool,
};
